export default "__VITE_ASSET__S7$pyjUR__"